module.exports = __webpack_public_path__ + "static/media/BB_amplify.7fa09f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_amplify.png
// module id = 1275
// module chunks = 0